(function () {
  if (window.ATKProductCollapsibleContent && typeof window.ATKProductCollapsibleContent.scheduleClamp === 'function') {
    window.ATKProductCollapsibleContent.scheduleClamp(document);
    return;
  } else if (window.ATKProductCollapsibleContent) {
    return;
  }

  var bound = false;
  var scheduled = false;

  function initClamp(container) {
    var root = container || document;
    var targetList = root.querySelectorAll('[data-focal-specs-clamp-target]');

    targetList.forEach(function (target) {
      var wrapper = target.closest('.clamp-wrapper');
      var btn = wrapper ? wrapper.querySelector('[data-focal-specs-clamp-button]') : null;

      if (!btn) {
        return;
      }

      var lineHeight = parseFloat(window.getComputedStyle(target).lineHeight);
      var shouldShow = target.scrollHeight > lineHeight * 5.5;

      btn.style.display = shouldShow ? 'block' : 'none';

      if (!shouldShow) {
        target.classList.remove('is-expanded');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = btn.dataset.showMoreText;
      }
    });
  }

  function scheduleClamp(container) {
    if (scheduled) {
      return;
    }

    scheduled = true;

    var run = function () {
      scheduled = false;
      initClamp(container || document);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 800 });
    } else {
      window.setTimeout(run, 120);
    }
  }

  function bind() {
    if (bound) {
      return;
    }

    bound = true;

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-focal-specs-clamp-button]');

      if (!btn) {
        return;
      }

      var wrapper = btn.closest('.clamp-wrapper');
      var target = wrapper ? wrapper.querySelector('[data-focal-specs-clamp-target]') : null;

      if (!target) {
        return;
      }

      var expanded = target.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? btn.dataset.showLessText : btn.dataset.showMoreText;
    });

    document.addEventListener('variant:changed', function () {
      window.setTimeout(function () {
        scheduleClamp(document);
      }, 200);
    });

    document.addEventListener('shopify:section:load', function (event) {
      scheduleClamp(event.target);
    });

    window.addEventListener('resize', function () {
      scheduleClamp(document);
    });
  }

  window.ATKProductCollapsibleContent = {
    bind: bind,
    initClamp: initClamp,
    scheduleClamp: scheduleClamp
  };

  bind();

  if (document.readyState === 'complete') {
    scheduleClamp(document);
  } else {
    window.addEventListener('load', function () {
      scheduleClamp(document);
    }, { once: true });
  }
})();
